// Login Actions
export const USER_IS_LOGGING_IN = 'USER_IS_LOGGING_IN';
export const LOG_IN_SUCCESSFUL = 'LOG_IN_SUCCESSFUL';
export const LOG_IN_UNSUCCESSFUL = 'LOG_IN_UNSUCCESSFUL';

// Teacher Session
export const IS_RETRIEVING_SESSION_INFO = 'IS_RETRIEVING_SESSION_INFO';
export const RETRIEVE_SESSION_INFORMATION_SUCCESS = 'RETRIEVE_SESSION_INFORMATION_SUCCESS';
export const RETRIEVE_SESSION_INFORMATION_ERROR = 'RETRIEVE_SESSION_INFORMATION_ERROR';

// Logout Actions
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_USER = 'SET_USER'; //Persistence

// Teacher Submit
export const IS_SUBMITTING = 'IS_SUBMITTING';
export const SUBMIT_SUCCESSFUL = 'SUBMIT_SUCCESSFUL';
export const SUBMIT_ERROR = 'SUBMIT_ERROR';
export const RESET_STUDENTS = 'RESET_STUDENTS';

//Teacher Clear Answers
export const BEGIN_CLEARING_ANSWERS = 'BEGIN_CLEARING_ANSWERS';
export const CLEAR_ANSWERS_SUCCESS = 'CLEAR_ANSWERS_SUCCESS';
export const CLEAR_ANSWERS_ERROR = 'CLEAR_ANSWERS_ERROR';

// Reset Session
export const RESET_SESSION = 'RESET_SESSION';
export const SET_SESSION = 'SET_SESSION';

// End Session
export const BEGIN_END_SESSION = 'BEGIN_END_SESSION';
export const END_SESSION_SUCCESSFUL = 'END_SESSION_SUCCESSFUL';
export const END_SESSION_ERROR = 'END_SESSION_ERROR';
export const END_SESSION_RESET = 'END_SESSION_RESET';

// General Student Actions
export const BEGIN_RETRIEVING_STUDENTS_LIST = 'BEGIN_RETRIEVING_STUDENTS_LIST';
export const RETRIEVING_STUDENTS_LIST_SUCCESS = 'RETRIEVING_STUDENTS_LIST_SUCCESS';
export const RETRIEVING_STUDENTS_LIST_ERROR = 'RETRIEVING_STUDENTS_LIST_ERROR';

// Specific Student Actions
export const SET_STUDENT_NAME = 'SET_STUDENT_NAME';
export const RESET_STUDENT_NAME = 'RESET_STUDENT_NAME';
export const SET_ANONYMOUS_USER = 'SET_ANONYMOUS_USER';
export const RESET_ANONYMOUS_USER = 'RESET_ANONYMOUS_USER';
export const SET_TEACHER_DETAILS = 'SET_TEACHER_DETAILS';

//adding student text to database
export const BEGIN_SYNCING_TEXT = 'BEGIN_SYNCING_TEXT';
export const STUDENT_SYNC_SUCCESS = 'STUDENT_SYNC_SUCCESS';
export const STUDENT_SYNC_ERROR = 'STUDENT_SYNC_ERROR';

//to unsubscribe to firestore listener
export const ADD_LISTENER = 'ADD_LISTENER';